export enum ValidationStatus {
    Success = 'success',
    Error = 'error',
    None = 'none',
}

export type Validator<T> = {
    validationMethod: (value?: T) => Promise<ValidationStatus>;
    validCallback?: (value?: T) => void;
    errorCallback?: (value?: T) => void;
};
